import { HeaderWithScrollables, IFlow } from '@diana/core';
import { WorkPageBreadcrumbs } from './WorkPageBreadcrumbs';
import { WorkPageRightHeader } from './WorkPageRightHeader';

export const WorkPageHeader = ({
  displayName = '',
  workCode = '',
  workId = '',
  flow,
}: {
  displayName?: string;
  workCode?: string;
  workId?: string;
  flow?: IFlow;
}) => (
  <HeaderWithScrollables
    left={
      <WorkPageBreadcrumbs
        displayName={displayName}
        workCode={workCode}
        workId={workId}
        flow={flow}
      />
    }
    right={<WorkPageRightHeader flow={flow} />}
  />
);
